import { derived } from 'svelte/store';
import { isActiveSlugRoute } from '../navigation';
import type { TBlock } from '../blocks/types';

export const isPracticeOrPlay = () =>
    derived([isActiveSlugRoute('PLAY'), isActiveSlugRoute('PRACTICE')], (stores) =>
        stores.some(Boolean)
    );

export const getReferences = (blockData: TBlock[]) => {
    const cssReferences = new Set<string>();
    const scriptReferences = new Set<string>();

    blockData.forEach((block) => {
        if (block.styles.decoded) {
            block.styles.decoded.forEach((style) => {
                if (!style) return;
                cssReferences.add(style);
            });
        }

        if (block.scriptSrc) {
            scriptReferences.add(block.scriptSrc);
        }
    });

    return {
        cssReferences: Array.from(cssReferences),
        scriptReferences: Array.from(scriptReferences)
    };
};
